import Logo from "@/components/Logo";
import { useLang } from "@/i18n";

export default function Navbar() {
  const { t, lang, setLang } = useLang();
  return (
    <nav className="sticky top-0 z-50 backdrop-blur-2xl bg-[#060709]/90 border-b border-[#212631] px-6 py-4" data-testid="main-nav">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-3.5 group" data-testid="brand-logo-link">
          <Logo size={40} className="shadow-lg shadow-[#c9a24d]/10 rounded-xl" />
          <div className="flex flex-col">
            <span className="font-geom text-base font-bold tracking-[0.2em] text-white" data-testid="brand-name">PRESTIGE DRIVE</span>
            <span className="font-mono text-[9px] text-[#c9a24d] tracking-[0.28em] uppercase">{t("brand.tag")}</span>
          </div>
        </a>

        <div className="hidden md:flex items-center gap-8 text-xs tracking-[0.18em] uppercase font-mono text-[#a1abb9]">
          <a href="#flotte" className="hover:text-[#c9a24d] transition-colors" data-testid="nav-fleet-link">{t("nav.fleet")}</a>
          <a href="#prestations" className="hover:text-[#c9a24d] transition-colors" data-testid="nav-services-link">{t("nav.services")}</a>
          <a href="#simulateur" className="hover:text-[#c9a24d] transition-colors" data-testid="nav-simulator-link">{t("nav.sim")}</a>
          <a href="#excellence" className="hover:text-[#c9a24d] transition-colors" data-testid="nav-reviews-link">{t("nav.reviews")}</a>
        </div>

        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1 font-mono text-[10px] uppercase tracking-widest" data-testid="lang-switcher">
            {["fr", "en", "ar"].map((l) => (
              <button key={l} onClick={() => setLang(l)} data-testid={`lang-${l}`}
                className={`px-2 py-1 rounded-md transition-colors ${lang === l ? "bg-[#c9a24d]/20 text-[#c9a24d] border border-[#c9a24d]/50" : "text-[#8c98a9] hover:text-white border border-transparent"}`}>
                {l}
              </button>
            ))}
          </div>
          <a href="#simulateur" data-testid="nav-quote-button"
            className="mt-2 font-geom px-5 py-2.5 text-xs font-bold uppercase tracking-widest bg-gradient-to-r from-[#c9a24d] via-[#d9b86c] to-[#a17c2e] text-[#060709] hover:brightness-110 transition-all rounded-full shadow-lg shadow-[#c9a24d]/20 border border-[#e3c07a]/40">
            {t("nav.cta")}
          </a>
        </div>
      </div>
    </nav>
  );
}
